import React from "react";
import cx from "classnames";
import styles from "./ProgressBar.module.scss";
import { ProgressBarProps } from "./ProgressBar.types";
import useBuildVariantProps from "../../../modules/theme/useBuildVariantProps";
import { calculatePercentageValue } from "./ProgressBar.utils";

const ProgressBar: React.FC<ProgressBarProps> = (props) => {
  const {
    value,
    min = 0,
    max = 100,
    // orientation = "Horizontal",
    showLabel,
    label,
    ariaLabel,
  } = props;
  // const isVertical = orientation === "Vertical";
  const percentage = calculatePercentageValue(value, min, max);
  const variantProps = useBuildVariantProps(
    "progress-bar",
    {
      // orientation,
      style: percentage > 0 ? "Filled" : "Empty",
    },
    {},
  );

  const progressBarAriaLabel = ariaLabel != null ? ariaLabel : `Progress bar ${value}%`;

  return (
    <div className={cx(styles.progressBarContainer, props.className)}>
      <div
        className={styles.progressBar}
        role="progressbar"
        aria-valuenow={value}
        aria-valuemin={min}
        aria-valuemax={max}
        aria-label={progressBarAriaLabel}
        {...variantProps}
      >
        {/* The progress indicator bar (decorative; presentational per progressbar role) */}
        <div
          className={styles.progressIndicator}
          style={{ width: `${percentage}%` }}
          aria-hidden="true"
        // style={{
        //   width: isVertical ? "100%" : `${percentage}%`,
        //   height: isVertical ? `${percentage}%` : "100%",
        // }}
        />

        {/* Show label if enabled, either as a percentage or custom text */}
        {showLabel && (
          <div className={styles.label}>
            {showLabel === "Percentage" ? `${Math.round(percentage)}%` : label}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProgressBar;
